"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var SizeStyleConfig = {
  large: {
    width: 'var(--spacing-global-space6)',
    // 24px
    height: 'var(--spacing-global-space6)'
  },
  medium: {
    width: 'calc(var(--spacing-global-space5) * 1.25)',
    // 20px
    height: 'calc(var(--spacing-global-space5) * 1.25)'
  },
  small: {
    width: 'var(--spacing-global-space5)',
    // 16px
    height: 'var(--spacing-global-space5)'
  }
};
var getVolumeByViewport = function getVolumeByViewport(swatchSize) {
  var _SizeStyleConfig$swat, _SizeStyleConfig$swat2;
  return "\n\twidth: ".concat((_SizeStyleConfig$swat = SizeStyleConfig[swatchSize]) === null || _SizeStyleConfig$swat === void 0 ? void 0 : _SizeStyleConfig$swat.width, ";\n\theight: ").concat((_SizeStyleConfig$swat2 = SizeStyleConfig[swatchSize]) === null || _SizeStyleConfig$swat2 === void 0 ? void 0 : _SizeStyleConfig$swat2.height, ";\n");
};
var setVolume = function setVolume(size) {
  var _buildResponsiveSize = (0, _fuseUtils.buildResponsiveSize)(size),
    _buildResponsiveSize2 = _slicedToArray(_buildResponsiveSize, 2),
    isResponsive = _buildResponsiveSize2[0],
    setViewportCss = _buildResponsiveSize2[1];
  return isResponsive ? setViewportCss(getVolumeByViewport) : getVolumeByViewport(size);
};
var StyledSwatch = _styledComponents["default"].span.attrs({
  className: 'fuse-swatch'
}).withConfig({
  displayName: "styled-swatch__StyledSwatch",
  componentId: "sc-iwv47y-0"
})(["display:inline-block;", " border-radius:50%;border:var(--border-width-xs) solid var(--color-functional-tintBlack20);", " ", ""], function (_ref) {
  var size = _ref.size;
  return setVolume(size);
}, function (_ref2) {
  var imageSrc = _ref2.imageSrc;
  return imageSrc && "\n\t\t\tbackground-image: url('".concat(imageSrc, "');\n\t\t\tbackground-size: cover;\n\t\t");
}, function (_ref3) {
  var colour = _ref3.colour;
  return colour && "\n\t\t\tbackground-color: ".concat(colour, ";\n\t\t");
});
var _default = exports["default"] = StyledSwatch;